export const context = {
  factsAboutMe: `- I am a male.
- I was born on September 30, 1982.
- I live in Amsterdam, The Netherlands.
- I am a Dutch citizen.`,
  into: `This text is about me, Jasper Schulte and my business ambitions.
I left Booking in May 1st 2025 and am planning to offer my services as a Engineering leader.
This should provide context about
- My background, history, experience and achievements
- What services and value I can offer
- What opportunities I am looking for`,
}
